<template>
  <div class="first_question">
        <div class="vertical-scroll">
            <div class="vertical-item">
                <div v-for="(item, index) in labels" 
                    :key="index"
                    :class="{first_question_item:true,question_item_selected:index===itemIdx}"
                    @click="changeQuestionItem(index,item)"
                >
                        <p>{{item.label}}</p>
                </div>
            </div>
        </div>

        <div class="scroll_change" v-if="labels.length>0">
            <span @click="scrollRight">
                <i
                :style="{ color: isScrollRight ? 'rgba(0, 0, 0, 0.15)' : '#0BAE6A' }"
                class="el-icon-arrow-left"
                ></i>
            </span>
            <span @click="scrollLeft" v-if="labels.length>0">
                <i
                :style="{ color: isScrollLeft ? 'rgba(0, 0, 0, 0.15)' : '#0BAE6A' }"
                class="el-icon-arrow-right"
                ></i>
            </span>
        </div>
  </div>
</template>

<script>
export default {
    props:{
        boxHeight:{
            type:String,
            default:'100rem'
        },
        labels:{
            type:Array,
            default:()=>[]
        }
        
    },
    data(){
        return{
            isScrollLeft:true,
            isScrollRight:true,
            itemIdx:'',
            clickNum: 0,
            lastLeft: 0,
            maxClickNum: 0, // 最大点击次数
        }
    },
   watch:{
        labels:{
            handler(val){
                if(val.length > 4){
                    this.isScrollLeft = false
                }
            }
        }

   },
    methods:{
        //切换试卷，清除流程一级题干选中样式
        resetItemIdx(){
         this.itemIdx = ''
        },
        defaultSelectFirst(){   //默认选中第一个标题
            this.$nextTick(()=>{
                if(this.labels.length){
                    this.changeQuestionItem(0,this.labels[0])
                }
            })
        },
        scrollRight(){
            // 当点击次数大于0时才触发，这样当点击次数clickNum等于1的到时候，clickNum--等于0.根据计算属性的判断会隐藏掉左箭头
            if (this.clickNum > 0) {
                this.isScrollLeft = false
                //获取当前元素宽度
                let width = document.querySelectorAll('.first_question_item')[this.clickNum - 1].offsetWidth
                // 公示：滚动距离（元素的magin-left值） = 它自己的长度 + 上一次滑动的距离
                document.querySelector('.vertical-item').style.marginLeft = `${width + this.lastLeft + 25}rem`
                this.lastLeft = width + this.lastLeft + 25
                //点击次数-1
                this.clickNum--
                if (this.clickNum == 0) {
                    this.isScrollRight = true
                }
            }
        },
        scrollLeft(){
            // 如果点击次数小于数组长度-1时，执行左滑动效果。
            if (this.clickNum < this.labels.length - 1) {
                //获取当前元素宽度
                let width = document.querySelectorAll('.first_question_item')[this.clickNum].offsetWidth
                // 获取最后一个元素距离左侧距离
                let lastItemOffsetLeft = document.querySelectorAll('.first_question_item')[this.labels.length - 1].offsetLeft
                // 获取可视区域宽度
                let lookWidth = document.querySelector('.vertical-scroll').clientWidth
                // 如果最后一个元素距离左侧的距离大于可视区域的宽度，表示最后一个元素没有出现，执行滚动效果
                if (lastItemOffsetLeft > lookWidth) {
                    this.isScrollRight = false
                    // 公示：滚动距离（元素的magin-left值） = 负的它自己的长度 + 上一次滑动的距离
                    document.querySelector('.vertical-item').style.marginLeft = `${-width + this.lastLeft-25}rem`
                    this.lastLeft = -width + this.lastLeft - 25
                    this.clickNum += 1
                    // 记录到最后一个元素出现在可视区域时，点击次数的最大值。用于后面点击左侧箭头时判断右侧箭头的显示
                    this.maxClickNum = this.clickNum
                }
        
                /* 
                如果最后一个元素距离左侧的距离大于可视距离+自身的宽度，说明没有到最后一个, 显示右侧箭头，否则隐藏右侧箭头
                注意：这里要加上其自身的宽度，否则要多点击一下才会隐藏。因为点击的时候实际上最后一个元素还没有滚动，
                它距离左侧的距离是大于可视区域的（也就是说获取的是上一次点击之后，距离左侧的距离）
                所以这里要加上其自身的宽度
            */
                this.isScrollLeft = lastItemOffsetLeft < lookWidth + width
            }            

        },
        changeQuestionItem(index,item){
            this.itemIdx = index
            this.$parent.getNowLabel(item)
        }
    },
}
</script>

<style lang="scss" scoped>
    .first_question{
        position: relative;
        display: flex;
        align-items: center;
        .vertical-scroll{
            overflow: hidden;
            flex: 1;
            width: 100%;
            .vertical-item{
                transition: all 0.3s ease;
                display: flex;
                align-items: center;
                .first_question_item{
                    width:130rem;
                    height:32rem;
                    cursor: pointer;
                    box-sizing: border-box;
                    line-height: 32rem;
                    background: #B6F9C9;
                    border-radius: 6rem;
                    margin-right: 25rem;
                    padding: 0 130rem 0 0;
                    p{
                        width:130rem;
                        text-align: center;
                        color: #303133;
                        font-size: 14rem;
                    }
                }
                .question_item_selected{
                    background: #B6F9C9;
                    color: var(--primary-color);
                    border: 1rem solid var(--primary-color);  
                    p{
                        color: var(--primary-color);
                    }
                }       
            }
        }
        .scroll_change{
            // width: 40rem;
            // display: flex;
            // justify-content: center;
        }
    }
</style>